export default __webpack_public_path__ + "static/media/anuj.16bd7b39.png";